import { jsx as _jsx } from "theme-ui/jsx-runtime";
/** @jsxImportSource theme-ui */
import React from "react";
import classic from "./themes/classic";
import wizard from "./themes/wizard";
import modern from "./themes/modern";
const FormThemeContext = React.createContext(
/** @type {FormThemeVariant | FormTheme | undefined} */
(undefined));
export default function useFormTheme() {
    const value = React.useContext(FormThemeContext);
    const layout = typeof value === "string" ? layouts[value] : value;
    return layout;
}
/**
 *
 * @param {object} props
 * @param {FormThemeVariant | FormTheme | undefined} props.value
 * @param {React.ReactNode} props.children
 * @returns
 */
export function FormThemeProvider({ value, children }) {
    const layout = typeof value === "string" ? layouts[value] : value;
    return (_jsx(FormThemeContext.Provider, { value: layout, children: children }));
}
const layouts = {
    classic,
    wizard,
    modern,
};
//# sourceMappingURL=useFormTheme.js.map